// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getQuizTypeById } from 'app/constants/enums/QuizType/main';

/* eslint-disable max-len */
export const FREEFORM = getQuizTypeById('Freeform');
export const MULTI_CHOICE = getQuizTypeById('MultiChoice');
export const MULTI_CHOICE_MANY = getQuizTypeById('MultiChoiceMany');
export const POOL = getQuizTypeById('Pool');
export const POOL_MANY = getQuizTypeById('PoolMany');
/* eslint-enable max-len */
